








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-arrow',

})
export default class IArrow extends Vue {

  @Prop({type: [String], default: '#494949'}) protected color!: string

}

